import * as React from 'react';
import { useState, useEffect, useContext } from 'react';

import { updateDoctorStatus } from '../Helper/API';
import { BackdropLoader } from '../BackdropLoader'
import { ToastEmitter } from '../ToastEmitter'
import { logEventToAnalyticsPlatform } from '../../../helper/events'
import {EVENTS} from '../events_Constant'
import  UserFeaturesContext  from '../../../hook/UserDetails/UserFeaturesContext';
import { checkFeatureFeasbility } from '../../../helper/utils';
import { FEATURE_NAME } from '../constant';
import { ToggleSwitch } from '../ToggleSwitch';

export const ProfileStatusPushButton = ({ doctorId, providerId, profileStatus, ...props }) => {
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { userFeatures } = useContext(UserFeaturesContext);
  const isButtonEnabled = checkFeatureFeasbility(FEATURE_NAME.UPDATE_DOCTOR_STATUS,userFeatures)


  const changeProfileStatus = async () => {
    try{
      let data = {
        isActive: checked ? false : true,
        providerIds: [providerId],
        doctorIds: [doctorId]
      }
      setIsLoading(true);
      const resp = await updateDoctorStatus(data);
      setIsLoading(false);
      if (resp.success) {
        setChecked(!checked);
        logEventToAnalyticsPlatform({
          name: EVENTS.PC_LS_ACTION.name,
          payload:{
            tab_name:EVENTS.TAB_NAME_LC_SCREEN,
            filterValue:'',
            reference_id:""+doctorId,
            reference_provider_id:""+providerId,
            service_name:EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
            action:EVENTS.ACTION.PROFILE_STATUS
          },
          schema: EVENTS.PC_LS_ACTION.schema,
        })
        ToastEmitter('Profile Status Updated Successfully', 'success');
      }
      else {
        ToastEmitter('Something went wrong Please Try Again', 'error');
      }
    }
    catch(err){
      setIsLoading(false);
      ToastEmitter('Something went wrong Please Try Again', 'error');
    } 
  }

 useEffect(() => {
  if(profileStatus!= undefined &&  profileStatus != null){
    setChecked(profileStatus)
  }
 },[profileStatus])

  return (
    <>
      {isLoading && <BackdropLoader isLoading={isLoading} />}
      <div className='flex flex-row gap-2'>
        {isButtonEnabled && <ToggleSwitch
          checked={checked}
          onChange={changeProfileStatus}        
          rounded
        />}
        <p className="text-sm text-normal flex justify-center py-1">{checked ? "Active" : "Deactive"}</p>
      </div>
    </>
  );
};

